import React, { useContext } from 'react';
import { UploadContext } from '../useUploadFiles';

const UploadTitle = () => {
  const { files, downloadFiles } = useContext(UploadContext);
  const uploadingFiles = files.filter((item) => item.meta.status === 'uploading').length;
  const downloadingFiles = downloadFiles.filter((item) => item.status === 'downloading').length;
  const completedUploadFiles = files.filter((item) => item.meta.status === 'done').length;
  const completeDownloadFiles = downloadFiles.filter((item) => item.status === 'done').length;

  let title = '';

  // Active
  const downloadPluralModifier = (downloadingFiles > 1 ) ? 's' : '';
  const uploadPluralModifier = (uploadingFiles > 1 ) ? 's' : '';

  // Copleted
  const downloadCompletedPluralModifier = (completeDownloadFiles> 1 ) ? 's' : '';
  const uploadCompletedPluralModifier = (completedUploadFiles> 1 ) ? 's' : '';

  if (downloadingFiles > 0 && uploadingFiles > 0) {
    title += `Downloading ${downloadingFiles} item${downloadPluralModifier}`
      + `, uploading ${uploadingFiles} item${uploadPluralModifier}`;
  } else if (downloadingFiles > 0 && uploadingFiles === 0 && completedUploadFiles > 0) {
    title += `Downloading ${downloadingFiles} item${downloadPluralModifier},`
      + ` ${completedUploadFiles} upload${uploadCompletedPluralModifier} complete`;
  } else if (uploadingFiles > 0 && downloadingFiles === 0 && completeDownloadFiles > 0) {
    title += `${completeDownloadFiles} download${downloadCompletedPluralModifier} complete,`
      + ` uploading ${uploadingFiles} item${uploadPluralModifier}`;
  } else if (completedUploadFiles > 0 && completeDownloadFiles > 0) {
    title += `${completeDownloadFiles} download${downloadCompletedPluralModifier} complete,`
      + ` ${completedUploadFiles} upload${uploadCompletedPluralModifier} complete`;
  } else if (uploadingFiles > 0) {
    title += `Uploading ${uploadingFiles} item${uploadPluralModifier}`;
  } else if (downloadingFiles > 0) {
    title += `Downloading ${downloadingFiles} item${downloadPluralModifier}`;
  } else if (completedUploadFiles > 0) {
    title += `${completedUploadFiles} upload${uploadCompletedPluralModifier} complete`;
  } else if (completeDownloadFiles > 0) {
    title += `${completeDownloadFiles} download${downloadCompletedPluralModifier} complete`;
  }

  return (
    <>
      {title}
    </>
  );
};

export default UploadTitle;
